/**
 * Die Meldestelle für `503 LIZENZ_NUR_LESEN` — Auftrag `LZ-oberflaeche`, Spec
 * `docs/superpowers/specs/2026-09-29-lizenzierung-design.md`, Abschnitt 8
 * (Oberfläche): „ein `503 LIZENZ_NUR_LESEN` einer beliebigen Aktion zeigt
 * denselben Text" wie das Hinweisband.
 *
 * **Warum ein eigenes Modul und nicht `api/client.ts`.** Der Klient ist die
 * einzige Stelle, die jede Antwort der API sieht (`toApiError()`), und ruft
 * `meldeLizenzNurLesen()` von dort. Die Empfänger (das Band in der Schale)
 * hängen aber nur an dieser kleinen Meldestelle — nicht am Klienten. Ein Test,
 * der `api/client` ersetzt (`apiClientMock`), ersetzt damit nicht die
 * Meldestelle, und jede bestehende Testdatei, die die Schale rendert, bleibt
 * unberührt: Das Band braucht dort keine Vorgabe für einen Export, den sie
 * nie kannte.
 *
 * **Mehrere Empfänger statt einer.** Anders als `onAuthRequired` (genau eine
 * Stelle reagiert) trägt sich hier jede eingehängte Schale ein; ein zweiter
 * Empfänger ersetzt den ersten nicht.
 */

type Empfaenger = () => void;

const empfaenger = new Set<Empfaenger>();

/** Trägt einen Empfänger ein; die Rückgabe trägt ihn wieder aus. */
export function beiLizenzNurLesen(fuer: Empfaenger): () => void {
  empfaenger.add(fuer);
  return () => {
    empfaenger.delete(fuer);
  };
}

/** Meldet allen Empfängern, dass eine Aktion an der Lizenzsperre gescheitert ist. */
export function meldeLizenzNurLesen(): void {
  for (const fuer of [...empfaenger]) fuer();
}
